import React, { useEffect } from 'react';

const ContactSuccess = () => {
  useEffect(() => {
    return () => {
      localStorage.removeItem('contact-success');
    };
  }, []);

  return (
    <div className="govuk-width-container">
      <main
        className="govuk-main-wrapper govuk-main-wrapper--l"
        id="main-content"
        role="main"
      >
        <div className="govuk-grid-row">
          <div className="govuk-grid-column-two-thirds">
            <div className="govuk-panel govuk-panel--confirmation">
              <h1 className="govuk-panel__title">
                Thank you. Your message has been sent
              </h1>
            </div>
            <h2 className="govuk-heading-m">What happens next</h2>
            <p className="govuk-body">
              We will review your message and respond to you using the email
              address provided. In the meantime please feel free to learn more
              about MyWishes Care with the tutorials provided.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ContactSuccess;
